module.exports = __webpack_public_path__ + "img/logo2.4c8f9c45.png";